import React from 'react';
import {connect} from 'react-redux';
import {BaseDashboard} from '../base-dashboard';

class Dashboard extends BaseDashboard {
    render() {
        const lineupsQuantity = this.getLineupsQuantity();

        return (
            <div className="lineups-info-holder">
                <ul className="lineups-info">
                    <li>
                        <strong>{lineupsQuantity}</strong> Lineups
                    </li>
                </ul>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {rawLineups},
        filterLineupsByKeyPlayerStackCombinations,
    } = state;

    return {
        rawLineups,
        filterLineupsByKeyPlayerStackCombinations,
    };
}

export default connect(mapStatesToProps)(Dashboard);
